export const DATE_VALUE_OPERATORS = {
	EXACT_DATE: 'EXACT_DATE',
	TODAY: 'TODAY',
	TOMORROW: 'TOMORROW',
	YESTERDAY: 'YESTERDAY',
	THIS_WEEK: 'THIS_WEEK',
	LAST_WEEK: 'LAST_WEEK',
	NEXT_WEEK: 'NEXT_WEEK',
	THIS_QUARTER: 'THIS_QUARTER',
	LAST_QUARTER: 'LAST_QUARTER',
	NEXT_QUARTER: 'NEXT_QUARTER',
	THIS_YEAR: 'THIS_YEAR',
	LAST_YEAR: 'LAST_YEAR',
	NEXT_YEAR: 'NEXT_YEAR',
};
